import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

const API_KEY = process.env.MIX_BUGSNAG_API_KEY;

// ユーザデータの読み込み
function dataset () {
    const data = document.querySelector('[data-roll="config"]');
    if (data && data.innerHTML) {
        return JSON.parse(data.innerHTML);
    }
}
const CONFIG = dataset();

/**
 * Bugsnagの初期化
 * 
 * @returns {Object} Bugsnagのプラグイン
 */
export const getBugsnag = function () {
    // ユーザ情報がないなら実行しない
    if (typeof CONFIG === 'undefined') return null;

    // Bugsnagの起動
    Bugsnag.start({
        apiKey: API_KEY,
        plugins: [new BugsnagPluginVue()],
        user: {
            id: CONFIG['user_contract']['id'],
            name: CONFIG['user']['shop_id'],
        }
    });

    return Bugsnag.getPlugin('vue');
};
